<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Ganti Metode
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">
                <h3>Ganti Metode Pembayaran</h3>
                <p>Berikut pilihan metode pembayaran yang telah kami sediakan. Monggo dipilih huehehe</p>
            </div>
            <div class="body">
                <div class="box" v-show="false">
                        <p class="red">
                            Maaf. Setelah uji coba perilisan kemarin ternyata masih banyak bug yang harus di benahi.
                            Jadi kami akan memperbaiki kembali ya gan. Terima kasih dan harap maklum :)
                        </p>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Outlet</span>
                        <small class="biru text-right">Biaya Admin Flat Rp. 6.000, Minimal Pembayaran Rp. 10.000</small>
                    </div>
                    <div class="bayar-item" @click="met.alfamart()"> <!--   -->
                        <img src="@/assets/alfamart.png" />
                        <div>
                            <span style="display:block">Alfamart</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                    <div class="bayar-item last comingsoon" @click="met.segera()">
                        <img src="@/assets/indomaret.png" />
                        <span>Indomaret</span>
                    </div>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Virtual Account</span>
                        <small class="biru text-right">Biaya Admin Flat Rp. 6.000</small>
                    </div>
                    <div class="bayar-item" @click="met.mandiri()">
                        <img src="@/assets/mandiri.png" />
                        <span>Mandiri Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.bri()"> <!--   -->
                        <img src="@/assets/bri.png" />
                        <span>BRI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.bni()">
                        <img src="@/assets/bni.png" />
                        <span>BNI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.permata()">
                        <img src="@/assets/permata.png" />
                        <span>PERMATA Virtual Akun</span>
                    </div>
                    <div class="bayar-item comingsoon" @click="met.segera()">
                        <img src="@/assets/bca.png" />
                        <span>BCA Virtual Akun</span>
                    </div>
                </div>
                <div class="box">
                    <div class="bayar-title">
                        <span class="block hitam">Dompet Digital</span>
                        <small class="biru text-right">Biaya Admin 1% dari Total Tagihan</small>
                    </div>
                    <div class="bayar-item" @click="met.ovo()">
                        <img src="@/assets/ovo.png" />
                        <span>Ovo</span>
                    </div>
                    <div class="bayar-item" @click="met.dana()">
                        <img src="@/assets/dana.png" />
                        <span>Dana</span>
                    </div>
                    <div class="bayar-item" @click="met.link()">
                        <img src="@/assets/link.png" />
                        <span>Link Aja</span>
                    </div>
                    <div class="bayar-item last" @click="met.qris()">
                        <img src="@/assets/qris.png" />
                        <span>QRIS (QR berstandar resmi Indonesia)</span>
                    </div>
                </div>
            </div>
            <div class="footer">
                <p class="text-center">Pembayaran diatas akan memproses tagihan anda secara otomatis.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/MyGlobal'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                allDone: false,
                custom: null,
                params: null
            })
        }

        const met = {
            segera() {
                myGlobal.android("toast", "Segera ya bun :)");
            },
            toDetail(jenisT,viaT) {
                router.push({ 
                    name: 'detail',
                    params: {
                        jenis: jenisT,
                        via: viaT,
                        qrid: get.data.params.qrid
                    }
                });
            },
            alfamart() {
                if (get.data.custom === 'custom') {
                    met.toDetail('retail','ALFAMART');
                }
            },
            permata() {
                met.toDetail('va','PERMATA');
            },
            bni() {
                met.toDetail('va','BNI');
            },
            bri() {
                met.toDetail('va','BRI');
            },
            mandiri() {
                met.toDetail('va','MANDIRI');
            },
            ovo() {
                met.toDetail('qris','ovo');
            },
            dana() {
                met.toDetail('qris','dana');
            },
            link() {
                met.toDetail('qris','linkaja');
            },
            qris() {
                met.toDetail('qris','qris');
            },
            
            back() {
                window.history.back();
            }
        }
        
        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            myGlobal,
            store,
            met,
            get,
            redirectx
        }

    },
    mounted () {
        //window.Token = this.token.get;
        
        this.redirectx.checkApp();
        
        if (sessionStorage.getItem("gantiData") == null) {
            sessionStorage.setItem("gantiData", JSON.stringify(this.$route.params));
            
            this.get.data.params = this.$route.params;
        } else {
            this.get.data.params = JSON.parse(sessionStorage.getItem("gantiData"));
        }
        

        this.get.data.this = this;        
        
        //myGlobal.android("setTitle", "Pilih Metode");

        if (sessionStorage.getItem("data_profil") != null) {
            var d = JSON.parse(sessionStorage.getItem("data_profil"));
            
            this.get.data.custom = d.atipe;
            console.log(d.atipe)

            //myGlobal.android("toast", d.atipe);
        }
        

        
        //this.store.dispatch('setToken', {'token': "blablabla"});

        
        
        //this.get.tagihan();

        // AMBIL TAGIHAN
        
        
        /*
        if (appmyrtrw) {
            appmyrtrw.setTitle("Pilih Metode");
            
            this.token.get(appmyrtrw.getToken()); 
            this.$store.commit('setToken', appmyrtrw.getToken());
        }
        */

        /*
        try {
        // eslint-disable-next-line no-undef
        } catch (error) {
            console.log("oops tidak boleh bambang");
            this.redirectx.now();
        } 
        */
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Ganti/main.vue